import React, {useEffect, useState} from 'react';
import TournamentX01Area from "./TournamentX01Area";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import DHDialog from "../../general/DHDialog";
import DHButtonDefault from "../../general/DHButtonDefault";

export default function LigaspieltagTeamGameModusBearbeitenDialog({tournamentId, onClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    const [sets, setSets] = useState(undefined)
    const [firstToLegs, setFirstToLegs] = useState(undefined)
    const [bestToLegs, setBestToLegs] = useState(undefined)
    const [modusId, setModusId] = useState(undefined)
    const [startpunkte, setStartpunkte] = useState(undefined)

    useEffect(() => {
        ladeModus()
    }, []);

    const ladeModus = () => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.ligaspieltag + "/teamgame/modus/"+ tournamentId,
            json => {
                setSets(json.sets);
                setFirstToLegs(json.firstToLegs);
                setBestToLegs(json.bestOfLegs);
                setModusId(json.modusid);
                setStartpunkte(json.startpunkte);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden: " + error.message);
            }
        );
    }


    const beschreibungArea = () => {
        return <div>
            Hier kannst du den Modus der Team-Games bearbeiten.<br/>
            <br/>
            <span style={{fontWeight:"bold"}}>Hinweis:</span> Sofern das Game schon am Scorer angezeigt wird, musst du das Game neu abholen. Gehe aus dem Game heraus und hole es über die entsprechende Seite im Scorer neu vom Server ab.
        </div>
    }

    const modusArea = () => {
        return <TournamentX01Area showSets={true} showBestOfLegs={true} showPflichtfelder={true}
                           sets={sets}
                           firstToLegs={firstToLegs}
                           bestOfLegs={bestToLegs}
                           modusId={modusId} startpunkte={startpunkte}
                           onSetsChanged={(sets) => setSets(sets)}
                           onFirstToLegsChanged={(firstToLegs) => setFirstToLegs(firstToLegs)}
                           onBestOfLegsChanged={(bestOfLegs) => setBestToLegs(bestOfLegs)}
                           onModusIdChanged={(modusId) => setModusId(modusId)}
                           onStartpunkteChanged={(startpunkte) => setStartpunkte(startpunkte)}/>
    }

    const canSave = () => {
        return sets && (firstToLegs || bestToLegs) && modusId && startpunkte
    }

    const saveTeamGame = () => {
        setErrorMessage(undefined);
        if( !canSave()) {
            setErrorMessage("Fülle den Spielmodus komplett aus.");
            return;
        }


        let modus = {
            gameType: "x01",
            modusid: modusId,
            sets: sets,
            firstToLegs: firstToLegs,
            bestOfLegs: bestToLegs,
            startpunkte: startpunkte,
        }

        FetchUtil.fetchPost(ConfigUtil.getConfig().resourceUrls.ligaspieltag + "/save/modus/teamgame/" + tournamentId,
            modus,
            () => {
                setInfoMessage("Erfolgreich gespeichert...")
            },
            responseNotOk => {
                setErrorMessage("Fehler: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler: " + error.message);
            })
    }

    return <DHDialog onClose={() => onClose()} title={"Team-Game Modus bearbeiten"} buttons={[]} comp={<>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div>
            {beschreibungArea()}
        </div>
        <div style={{marginTop:20}}>
            <div style={{marginBottom:10}}>
                Wählen den Modus des Team-Games:
            </div>
            <div style={{marginTop: 10, alignItems: "center"}}>
                {modusArea()}
            </div>
            <div style={{marginTop:20}}>
                Möchtest du den Modus der Team-Games wirklich speichern?
            </div>
        </div>
        <div style={{marginTop: 20}}>
            <div>
                <DHButtonDefault label={"Speichern"} onClick={() => saveTeamGame()} />
                <DHButtonDefault label={"Abbrechen"} onClick={() => onClose()} className="p-button-secondary" />
            </div>
        </div>
    </>}/>
}